import { createFileRoute } from '@tanstack/react-router'
import { GetTheAppPage } from '@/features/get-the-app/get-the-app-page'

export const Route = createFileRoute('/_authenticated/get-the-app')({
  component: GetTheAppPage,
})
